/*
 * Copyright © 2020-2026 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2026-03-06 11:48:17
 */
import CONFIG from '../../constants/config'
import photoIcon from './assets/photo.png'
import memberIcon from './assets/member.png'
import watermarkIcon from './assets/watermark.png'
import storageIcon from './assets/storage.png'

import moreIcon from './assets/more.png'
import aiIcon from './assets/ai.svg'

const VIP_KIND = CONFIG.VIP_KIND

/** 会员卡片单条权益 */
export interface MemberFeature {
  label: string
  value: string
  /** 设计稿 NEW 角标（AI 类新权益） */
  isNew?: boolean
}

/** 会员卡片配置 */
export interface Member {
  title: string
  subTitle: string
  price: number
  vipKind: number
  priceSuffix: string
  buttonText: string
  features: MemberFeature[]
}

export const MEMBER_CONFIG: Member[] = [
  {
    title: '免费版',
    subTitle: '基础功能体验',
    price: 0,
    vipKind: 0,
    priceSuffix: '元/月起',
    buttonText: '免费使用',
    features: [
      { label: '存储空间', value: '1万张' },
      { label: '人数上限', value: '50人' },
      { label: '照片查看天数', value: '90天' }
    ]
  },
  {
    title: '基础会员',
    subTitle: '小型团队，高效协同首选',
    price: 17,
    vipKind: VIP_KIND.VIP,
    priceSuffix: '元/月起',
    buttonText: '立即开通',
    features: [
      { label: '存储空间', value: '10万张' },
      { label: '人数上限', value: '50人' },
      { label: '照片查看天数', value: '1年' },
      { label: '照片/Excel批量下载', value: '享有' },
      { label: '编辑水印/去水印', value: '1000次' }
    ]
  },
  {
    title: '高级会员',
    subTitle: '中型团队，业务管理最佳',
    price: 34,
    vipKind: VIP_KIND.VVIP,
    priceSuffix: '元/月起',
    buttonText: '立即开通',
    features: [
      { label: '存储空间', value: '20万张' },
      { label: '人数上限', value: '100人' },
      { label: '照片查看天数', value: '2年' },
      { label: '照片/Excel批量下载', value: '享有' },
      { label: '编辑水印/去水印', value: '3000次' },
      { label: 'AI 统计/填表/分类', value: '体验', isNew: true }
    ]
  },
  {
    title: '超级会员',
    subTitle: '大型团队，助力企业数字化转型',
    price: 83,
    vipKind: VIP_KIND.SVIP,
    priceSuffix: '元/月起',
    buttonText: '立即开通',
    features: [
      { label: '存储空间', value: '50万张' },
      { label: '人数上限', value: '200人' },
      { label: '照片查看天数', value: '无限' },
      { label: '照片/Excel批量下载', value: '享有' },
      { label: '编辑水印/去水印', value: '10000次' },
      { label: 'AI 统计/填表/分类', value: '畅享', isNew: true }
    ]
  }
]

export const VIP_KIND_NAMES = {
  [VIP_KIND.VIP]: '基础会员',
  [VIP_KIND.VVIP]: '高级会员',
  [VIP_KIND.SVIP]: '超级会员',
  [VIP_KIND.EVIP]: '企业级会员'
}

export const PRIVILEGE_COMPARE_CONFIG = [
  {
    category: '照片管理',
    icon: photoIcon,
    items: [
      {
        label: '存储空间',
        values: ['1万张', '10万张', '20万张', '50万张', '更多空间']
      },
      {
        label: '照片查看天数',
        values: ['90天内', '1年内', '2年内', '无限', '无限']
      },
      {
        label: '照片批量下载',
        values: ['-', '2000张', '10000张', '20000张', '20000张']
      },
      { label: '台账表下载', values: ['-', true, true, true, true] },
      { label: '照片多级分类下载', values: ['-', '-', true, true, true] },
      { label: '高级命名方式', values: ['-', '-', true, true, true] },
      {
        label: '分类文件夹',
        values: ['1个', '20个', '100个', '2000个', '更多个数']
      }
    ]
  },
  {
    category: 'AI 智能',
    icon: aiIcon,
    items: [
      {
        label: 'AI 积分',
        subLabel: '用于 AI 功能消耗',
        values: ['50万/一次性', '50万/月', '600万/月', '3000万/月', '更多积分']
      },
      {
        label: 'AI 问答',
        isNew: true,
        values: ['限时体验', true, true, true, true]
      },
      {
        label: 'AI 填表',
        isNew: true,
        values: ['限时体验', true, true, true, true]
      },
      {
        label: 'AI 批量分类',
        isNew: true,
        values: ['-', '-', true, true, true]
      }
    ]
  },
  {
    category: '人员管理',
    icon: memberIcon,
    items: [
      {
        label: '人数上限',
        values: ['50人', '50人', '100人', '200人', '更多人数']
      },
      { label: '管理员数', values: ['1人', '2人', '4人', '无限', '无限'] },
      { label: '部门管理', values: ['-', '-', '-', true, true] }
    ]
  },
  {
    category: '水印管理',
    icon: watermarkIcon,
    items: [
      { label: '团队水印数量', values: ['1个', '4个', '8个', '无限', '无限'] },
      {
        label: '编辑/去水印',
        subLabel: '时间地点不可改',
        subLabelStyle: 'danger',
        values: ['-', '1000张', '3000张', '10000张', '更多张数']
      },
      { label: '仅使用团队水印', values: ['-', true, true, true, true] },
      { label: '拍照后加水印', values: ['-', '-', '-', true, true] }
    ]
  },
  {
    category: '同步设置',
    icon: storageIcon,
    items: [
      { label: '同步高清原图', values: ['-', true, true, true, true] },
      { label: '同步长视频', values: ['-', '-', true, true, true] },
      { label: '强制开启同步', values: ['-', '-', true, true, true] },
      { label: '同步无水印照片', values: ['-', '-', true, true, true] },
      { label: '同步团队照片不保存本地', values: ['-', '-', true, true, true] },
      { label: '电脑批量上传', values: ['-', '-', true, true, true] }
    ]
  },
  {
    category: '更多权益',
    icon: moreIcon,
    items: [
      {
        label: '查看拍照路线',
        values: ['当天', '全部', '全部', '全部', '全部']
      },
      { label: '整改任务', values: ['10条', '10条', '无限', '无限', '无限'] },
      { label: '自动转发', values: ['-', '-', true, true, true] },
      { label: '预设多级选项', values: ['-', true, true, true, true] },
      { label: '导航验真二维码', values: ['-', '-', true, true, true] },
      {
        label: '客户拜访',
        values: ['-', '赠2席位', '赠5席位', '赠10席位', '更多席位']
      },
      { label: '客户批量删除', values: ['-', '-', '-', true, true] },
      { label: '团队拼图模版', values: ['-', '-', true, true, true] },
      { label: '团队操作日志', values: ['-', '-', true, true, true] },
      { label: '无右下角水印', values: ['-', '-', true, true, true] },
      { label: '无车牌宣传水印', values: ['-', '-', true, true, true] },
      { label: '品牌主题样式', values: ['-', '-', true, true, true] },
      {
        label: '专属语音客服',
        subLabel: '(仅团队管理员)',
        values: ['-', true, true, true, true]
      }
    ]
  }
]
